<template>
    <div class="item_list" :class="{ android: android }">
        <title-bar :title="teamName">
            <router-link :to="{ name: 'info' }" slot="left" class="user_info_icon">
                <img class="logo_icon" :src="avatar && avatar !== 'null' ? avatar : defaultAvatar" />
            </router-link>
            <div class="select-group" slot="right">
                <router-link :to="{ name: 'group', query: { type: 'search' } }" class="group-find">
                    <img src="@/assets/imgs/group_find.svg" />
                </router-link>
                <router-link :to="{ name: 'group', query: { type: 'list' } }" class="group-menu">
                    <img src="@/assets/imgs/group_menu.svg" />
                </router-link>
            </div>
        </title-bar>
        <img :src="avatar" style="display: none" />
        <div class="no-content" v-if="warn">
            <img src="@/assets/imgs/rectangle.png" />
        </div>
        <ul class="list" id="list" v-else>
            <li v-for="(item, index) in list" :key="index">
                <v-touch @tap="goToItem(item.id)">
                    <div class="li_con">
                        <div class="desc">
                            <h3 class="name">{{ item.name }}</h3>
                            <p class="type">-- {{ typeStr[item.type] }} --</p>
                        </div>
                        <img class="cover_bg" v-lazy="item.cover.url" />
                    </div>
                </v-touch>
            </li>
        </ul>
    </div>
</template>

<script>
import titleBar from "@/components/layout/TitleBar"
export default {
    name: "itemList",
    data() {
        return {
            list: [],
            typeStr: {
                mobile: "手机APP",
                web: "网页web"
            },
            warn: false
        }
    },
    computed: {
        teamName() {
            return localStorage.teamName
        },
        defaultAvatar() {
            return require("../../assets/imgs/logo_icon.png")
        },
        android() {
            return window.system === "android"
        },
        avatar() {
            if (localStorage.itemPageAvatar) {
                return localStorage.avatar
            } else {
                return false
            }
        }
    },
    components: {
        titleBar
    },
    mounted() {
        this.getProjects()
    },
    methods: {
        async getProjects() {
            this.$root.eventBus.$emit("showLoading")
            let teamId = this.$route.query.team_id || localStorage.teamId
            let params = { team_id: teamId, pageSize: 300, time_order: "desc" }
            let res = await lanhuAPI.project.getProjectListOrigin(teamId, { time_order: "desc" })
            this.$root.eventBus.$emit("hideLoading")

            let width = document.documentElement.clientWidth

            if (res) {
                // let data = res.data
                this.list = res.map(ele => {
                    ele.cover.url = window.mtd.handleImg(ele.cover.url, {
                        ali: this.$root.isSupportWebp
                            ? `?x-oss-process=image/blur,r_15,s_15/resize,w_${width}/format,webp`
                            : `?x-oss-process=image/blur,r_15,s_15/resize,w_${width}`,
                        qiniu: `?imageMogr2/w/${width}blur/15x15`
                    })

                    return ele
                })
            }
            if (this.list.length == 0) {
                this.warn = true
            }
        },
        goToItem(project_id) {
            this.$router.push({
                name: "item",
                query: {
                    project_id: project_id
                }
            })
        },
        toStory() {
            if (isWebview) {
                let ref = cordova.InAppBrowser.open(
                    `https://report.${window.domain}.com?user_id=` + localStorage.userId + "&f=" + this.$root.system,
                    "_system",
                    "location=yes"
                )
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.item_list {
    &.android {
        padding-top: 3.45rem !important;
    }
    height: 100%;
    padding-top: 3.35rem; //ios_top
    padding-top: calc(constant(safe-area-inset-top) + 2.35rem);
    padding-top: calc(env(safe-area-inset-top) + 2.35rem);
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    .select-group {
        top: 0.1rem;
        position: relative;
        .group-menu,
        .group-find {
            vertical-align: middle;
            width: 1.15rem;
            display: inline-block;
            color: #5b606a;
            opacity: 0.7;
        }
        .group-menu {
            padding: 0.3rem 0 0.3rem 0.3rem;
        }
        .group-find {
            position: relative;
            padding: 0.3rem;
        }
        img {
            width: 100%;
        }
    }
    .user_info_icon {
        height: 100%;
        position: relative;
        display: block;
        .logo_icon {
            border-radius: 50%;
            width: 1.5rem;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translate(0, -50%);
        }
    }
    .no-content {
        text-align: center;
        position: absolute;
        left: 0;
        top: 25%;
        width: 100%;
        img {
            width: 13.25rem;
            height: 12.5rem;
        }
    }
    .list {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        overflow-y: auto;
        li {
            width: 17.25rem;
            margin: 0.68rem auto 0 auto;
            height: 8rem;
            overflow: hidden;
            position: relative;
            border-radius: 0.2rem;

            &:last-child {
                margin-bottom: 2rem;
            }

            .li_con {
                width: 100%;
                height: 100%;
            }

            .desc {
                width: 100%;
                height: 100%;
                border-radius: 0.2rem;
                overflow: hidden;
                background: rgba(0, 0, 0, 0.4);
                text-align: center;
                position: absolute;
                left: 0;
                top: 0;
                z-index: 11;
                color: #ffffff;
                .name {
                    width: 13.1rem;
                    margin: 0 auto;
                    padding-top: 2.5rem;
                    font-size: 1rem;
                    text-shadow: 0px 0px 0px rgba(0, 0, 0, 0.7);
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
                .type {
                    width: 100%;
                    position: absolute;
                    left: 0;
                    bottom: 1rem;
                    font-size: 0.7rem;
                }
            }
            .cover_bg {
                width: 100%;
                background-size: 100%;
            }
        }
    }
}
</style>
